import React, { useEffect, useState } from "react";
import not1 from "../assets/images/not1.svg";
import not2 from "../assets/images/not2.svg";
import not3 from "../assets/images/not3.svg";
import not4 from "../assets/images/not4.svg";
import { Link } from "react-router-dom"; // Import Link

const notifications = [
  {
    id: 1,
    type: "notifications",
    username: "Atheist Community",
    content: "Invited you to join this club, Pulp, the cocktail bar at The Park, Kolkata epitomizes the glamour and the style of the 60s. The highlight of the place is its spatial simplicity!!",
    profilePic: not1,
    time: "5m",
    date: "2025-01-07T19:00:00"
  },
  {
    id: 2,
    type: "notifications",
    username: "Name Surname",
    content: "Commented on your post",
    profilePic: not2,
    time: "12m",
    date: "2025-01-07T19:00:00"
  },
  {
    id: 3,
    type: "notifications",
    username: "Logical Thinkers",
    content: "Created a new poll form this club",
    profilePic: not3,
    time: "25m",
    date: "2025-01-07T19:00:00"
  },
  {
    id: 4,
    type: "notifications",
    username: "Food Lovers Club",
    content: "Commented on your post",
    profilePic: not4,
    time: "32m",
    date: "2025-01-07T19:00:00"
  },
  {
    id: 5,
    type: "notifications",
    username: "Atheist Community",
    content: "Invited you to join this club",
    profilePic: not2,
    time: "40m",
    date: "2025-01-07T19:00:00"
  },
  {
    id: 6,
    type: "notifications",
    username: "Name Surname",
    content: "Commented on your post",
    profilePic: not3,
    time: "52m",
    date: "2025-01-07T19:00:00"
  },
  {
    id: 7,
    type: "notifications",
    username: "Rock Music Club",
    content: "Rock Music Club send you Tickets.",
    profilePic: not3,
    time: "52m",
    date: "2025-01-07T19:00:00"
  },
  {
    id: 8,
    type: "notifications",
    username: "Soft Music Club",
    content: "Soft Music Club send you Tickets.",
    profilePic: not2,
    time: "52m",
    date: "2025-01-07T19:00:00"
  },
  {
    id: 9,
    type: "notifications",
    username: "Snks Lovers Club",
    content: "Commented on your post",
    profilePic: not4,
    time: "32m",
    date: "2025-01-07T19:00:00"
  },
];

const Notification = ({ notification }) => {
  const [isRead, setIsRead] = useState(true);
  useEffect(() => {
    const readNotifications = JSON.parse(localStorage.getItem('readNotifications') || '[]');
    setIsRead(readNotifications.includes(notification.id));
  }, [notification.id]);
  const truncateContent = (content, maxWords) => {
    const words = content.split(' ');
    return words.length > maxWords ? words.slice(0, maxWords).join(' ') + '...' : content;
  };
  return (
    <Link
      to={`/notifications/${notification.id}`}
      state={{ notification }}
      className={`publication-card publication-card-ancher publication-card-small ${!isRead ? "unread" : ""}`}
    >
      <div className="left-section">
        <div className="publication-logo">
            <img src={notification.profilePic} alt={notification.username}  />
        </div>
        <div className="publication-info">
          <h4>{notification.username}</h4>
          <p>{truncateContent(notification.content, 5)}</p>
        </div>
      </div>
      <div className="publication-card-time">{notification.time}</div>
    </Link>
  );
};

const NotificationsList = () => {
  const [visible, setVisible] = useState(5);

  const handleViewMore = () => {
    setVisible((prev) => prev + 5);
  };

  return (
    <div className="newsportal-wrapper notifications">
      {notifications.slice(0, visible).map((notification) => (
        <Notification key={notification.id} notification={notification} />
      ))}

      {visible < notifications.length && (
        <button className="view-more-btn" onClick={handleViewMore}>
          View More
        </button>
      )}
    </div>
  );
};

export { notifications }; // clearly add this line
export default NotificationsList; // keep this line
